import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useHref, useT } from "@/i18n";

export default function NotFound() {
  const href = useHref();
  const t = useT();
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center sm:px-8">
      <p className="font-display text-6xl font-extrabold tracking-tight text-primary">404</p>
      <h1 data-testid="not-found-title" className="mt-4 font-display text-2xl font-bold tracking-tight">
        {t("notFound.title")}
      </h1>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">{t("notFound.body")}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to={href("/directory")}>
          <Button data-testid="not-found-directory-button">{t("notFound.directory")}</Button>
        </Link>
        <Link to={href("/harga")}>
          <Button variant="outline" data-testid="not-found-pricing-button">
            {t("notFound.pricing")}
          </Button>
        </Link>
      </div>
    </div>
  );
}
